module.exports = __webpack_public_path__ + "static/media/autochat_logo.b56b891d.svg";